import { Link } from 'react-router-dom';
import { CheckCircle2, ExternalLink, Megaphone, Search, Sparkles } from 'lucide-react';
import { paths } from '../lib/paths';

const CHECKS = [
  'Top League Login points to League HQ.',
  'Footer Scorekeeper Company Login points to Scorekeeper HQ.',
  'Book a demo CTA uses the smart lead form.',
  'Privacy and Terms links stay in the footer.',
  'Public copy stays roller-hockey specific.',
];

const CONTENT_IDEAS = [
  'League management software for roller hockey',
  'AI-powered scheduling and communications',
  'Advanced analytics for roller hockey leagues',
  'Modern scorekeeping and live league updates',
];

export function CompanyMarketingPage() {
  return (
    <div className="stack" style={{ gap: 18 }}>
      <section className="card" style={{ padding: 24 }}>
        <div className="eyebrow">Scorekeeper HQ</div>
        <h1 style={{ margin: '6px 0 0', fontSize: 30 }}>Marketing/SEO</h1>
        <p className="muted" style={{ maxWidth: 760, marginTop: 10 }}>
          Track growth work, public-page checks, SEO ideas, and CTA hygiene
          without turning the website into a CMS yet.
        </p>
        <div className="row" style={{ gap: 10, marginTop: 18 }}>
          <Link to={paths.marketingHome} className="btn btn--primary">
            <ExternalLink size={14} /> Public home
          </Link>
          <Link to={paths.contact} className="btn">
            Demo form
          </Link>
        </div>
      </section>

      <div className="grid grid--2" style={{ gap: 16 }}>
        <section className="card" style={{ padding: 22 }}>
          <h3 className="card__title" style={{ margin: 0 }}>
            <Megaphone size={16} style={{ verticalAlign: -2, marginRight: 6 }} />
            Public funnel checks
          </h3>
          <div className="stack" style={{ gap: 10, marginTop: 14 }}>
            {CHECKS.map((check) => (
              <div key={check} className="row" style={{ gap: 8, alignItems: 'center' }}>
                <CheckCircle2 size={16} style={{ color: 'var(--ok)' }} />
                <span>{check}</span>
              </div>
            ))}
          </div>
        </section>

        <section className="card" style={{ padding: 22 }}>
          <h3 className="card__title" style={{ margin: 0 }}>
            <Search size={16} style={{ verticalAlign: -2, marginRight: 6 }} />
            SEO targets
          </h3>
          <p className="muted" style={{ marginTop: 8 }}>
            V1 keeps these as internal prompts for future public copy and page
            improvements. Website editing remains code-managed.
          </p>
          <div className="row" style={{ gap: 8, flexWrap: 'wrap', marginTop: 14 }}>
            {CONTENT_IDEAS.map((idea) => (
              <span key={idea} className="chip chip--info">{idea}</span>
            ))}
          </div>
        </section>

        <section className="card" style={{ padding: 22 }}>
          <h3 className="card__title" style={{ margin: 0 }}>
            <Sparkles size={16} style={{ verticalAlign: -2, marginRight: 6 }} />
            Next growth layer
          </h3>
          <p className="muted" style={{ marginTop: 8 }}>
            Later this can connect analytics, campaign sources, landing pages,
            and conversion reporting. For now, the company dashboard owns the
            checklist and the pipeline owns conversion movement.
          </p>
        </section>
      </div>
    </div>
  );
}
